export const isDevelopment =
  location.origin !== "https://calm-pond-0e8c41a03.6.azurestaticapps.net";
export const API_BASE_URL = isDevelopment
  ? "https://localhost:5000"
  : "https://api.fh-krems.ac.at/v2.0";
